// extracted by mini-css-extract-plugin
var _1 = "Cell_defaultTitleContent__33b68";
var _2 = "Cell_root__fba51";
var _3 = "Cell_span__29ab0";
var _4 = "Cell_td__98d5f";
var _5 = "Cell_th__3270f";
export { _1 as "defaultTitleContent", _2 as "root", _3 as "span", _4 as "td", _5 as "th" }
